module.exports = __webpack_public_path__ + "static/media/hohlogo.642ece28.png";